<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Tutar
    </div>
    <div class="font-weight-bolder text-danger font-medium-2">
      {{ dataItem.amount | toCurrency }} {{ dataItem.currency? dataItem.currency : 'TL' }}
    </div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'Amount',
  components: {
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
